import _ from "lodash";
import * as React from "react";
import { Link } from "react-router-dom";
import * as M from "../../models";
import { Utility } from "../../utils";
import { ReviewField } from "../editors";
import { WrapperLess } from "../generic";

interface OwnProps {
    form: M.FormBuilder.Form;
    submission?: M.FormBuilder.FormSubmission;
    isAuthorReview?: boolean;
    editLink?: string;
}

interface OwnState {
}

export class FormSubmissionSummary extends React.Component<OwnProps, OwnState> {
    public render() {
        const sections = _.orderBy(this.props.form.sections, "sort");

        return sections.map((s, i) => {
            const editLink = this.props.editLink
                ? <WrapperLess> &mdash; <Link to={this.props.editLink + "#section-" + Utility.toSlug(s.title)}>Edit</Link></WrapperLess>
                : null;

            const title = s.title
                ? <h2>{s.title}{editLink}</h2>
                : null;

            const description = s.description
                ? <div dangerouslySetInnerHTML={{ __html: s.description }} />
                : null;

            const fields = _.orderBy(s.fields, "sort").map((f, j) => {
                const value = this.props.submission
                    ? _.find(this.props.submission.answers, (a) => a.fieldId === f.fieldId)
                    : undefined;

                const fieldDisplay = M.FormBuilder.FormSubmissionHelper.getFieldValueDisplay(f, value ? value.answer : undefined);

                return <ReviewField key={j} label={f.metaData.label} isHtml={fieldDisplay.isHtml}>
                        {fieldDisplay.value}
                    </ReviewField>;
            });

            return <WrapperLess key={i}>
                {title}
                {description}
                {fields}
            </WrapperLess>;
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/formBuilder/FormSubmissionSummary.tsx